// <auto-generated>
// Generated from contracts/renderer-bridge.json by openapi-typescript 7.13.0 (pnpm contracts:generate). Do not edit.
// contract-sha256: 33126e2298ba3b1683046d4697c8390c8dc82d1a4d1e550a0f0e8016f398e620
// </auto-generated>
export const EDITOR_TO_RENDERER_MESSAGE_TYPES = [
  "setJwt",
  "checkCanvasReady",
  "requestScreenshot",
  "timelinePlay",
  "timelinePause",
  "timelineStop",
  "timelineSeek",
  "assetInstanceAdded",
  "assetInstanceUpdated",
  "assetInstanceLockChanged",
  "assetInstanceVisibilityChanged",
  "assetInstanceRemoved",
  "keyframeAdded",
  "keyframeUpdated",
  "keyframeRemoved",
  "clipInstanceAdded",
  "clipInstanceUpdated",
  "clipInstanceRemoved",
  "uiElementInstanceAdded",
  "uiElementInstanceUpdated",
  "uiElementInstanceRemoved",
  "materialInstanceUpserted",
  "materialInstanceRemoved",
  "vfxInstanceAdded",
  "vfxInstanceUpdated",
  "vfxInstanceRemoved",
  "selectKeyframe",
  "clearSelection",
  "setCamera",
  "recenterView",
  "setSkybox",
  "setViewportTheme",
  "setZoomSensitivity",
] as const;

export const RENDERER_TO_EDITOR_MESSAGE_TYPES = [
  "requestJwt",
  "rendererLoaded",
  "rendererError",
  "pointerDown",
  "keyboardEvent",
  "canvasReadyResponse",
  "screenshotResponse",
  "sceneLoaded",
  "assetInstanceLoaded",
  "assetInstanceSelected",
  "selectionCleared",
  "keyframeSelected",
  "cameraToggled",
  "assetInstanceTransformsEdited",
  "keyframeTransformsEdited",
  "assetInstanceRequested",
  "clipTypesDiscovered",
] as const;
